export const PauseIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Pause",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path d="M7 5H10V19H7V5ZM14 5H17V19H14V5Z" fill="currentColor" />
    </svg>
  );
};
